import React from 'react'
import styled from 'styled-components'
import { Dropdown, SFSymbolLabel } from '@sketch/components'

import { useVersioning } from '../../../../versioning'
import { formatSymbolPath } from '../../../utils'
import { routes } from '@sketch/modules-common'

interface SymbolPathLinkDropdownProps {
  paths: string[]
  prefix?: string
}

export const DropdownLink = styled(Dropdown.Item.NavLink)`
  white-space: pre;
`

export const SymbolPathLinkDropdown = ({
  paths,
  prefix,
}: SymbolPathLinkDropdownProps) => {
  const { share } = useVersioning()

  return (
    <>
      {paths.map((path, index) => (
        <DropdownLink
          key={index}
          to={routes.CWV_SYMBOLS.create({
            shareID: share.identifier,
            query: {
              // encodeURIComponent was added to prevent paths with " " to be broken URLs
              g: encodeURIComponent(
                [
                  ...(prefix ? [prefix] : []),
                  ...paths.slice(0, index),
                  path,
                ].join('/')
              ),
            },
          })}
        >
          <SFSymbolLabel text={formatSymbolPath(path, index)} />
        </DropdownLink>
      ))}
    </>
  )
}
